import { ProgressIndicator, ProgressStep } from 'carbon-components-react';

import messages from '../../../locales/messages';
import './ProgressBar.scss';
import { createUseTranslation } from 'src/common/hooks/widgets/useTranslation';
import { useQradarEDRSelector } from '../../../lib/redux/hooks';

type ProgressProps = {
  step: number;
};

export const Progress = ({ step }: ProgressProps) => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  return (
    <div className="pbar">
      <ProgressIndicator
        currentIndex={step}
        spaceEqually={true}
        className="ProgressBar"
      >
        <ProgressStep
          label={useTranslation('ladingPage_Step1')}
          className="Progressstep"
        ></ProgressStep>
        <ProgressStep
          className="step Progressstep"
          label={useTranslation('ladingPage_Step2')}
        ></ProgressStep>
        <ProgressStep
          label={useTranslation('ladingPage_Step3')}
          className="Progressstep"
        ></ProgressStep>
      </ProgressIndicator>
    </div>
  );
};
